<template>
  <Popup
    :title="title"
    :visible="visible"
    :singleBtn="true"
    @popupCancle="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form>
        <a-form-item
          label="验证码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <div class="code">
            <a-input
              size="large"
              :max-length="4"
              placeholder="请输入图形验证码"
              v-model="graphicCode"
            >
              <div slot="suffix" class="codeImg cursor" @click="getGraphicCode">
                <img v-if="codeImg == ''" src="@/assets/checkcode.png" alt="" />
                <img v-else :src="codeImg" alt="" />
              </div>
            </a-input>
            <a-button type="primary" @click="handleReset">{{ title }}</a-button>
          </div>
        </a-form-item>

        <a-form-item label="密匙" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <span>{{ secretKey }}</span>
        </a-form-item>
      </a-form>
    </a-spin>
  </Popup>
</template>
<script>
import { postAction, getAction } from '@/api/manage';
import Popup from '@/components/common/Popup';
export default {
  name: 'LookKeyModal',
  components: {
    Popup
  },
  data() {
    return {
      visible: false,
      isDisable: false,
      title: '操作',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 14 },
        sm: { span: 12 }
      },
      confirmLoading: false,
      url: {
        resetKey: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/app/reset/key',
        checkKey: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/app/get/key',
        randomImage:
          process.env.VUE_APP_CMS_SYSTEM +
          `/sys/randomImage/${this.currdatetime}`
      },
      recordId: '',
      codeImg: '',
      graphicCode: '',
      isReset: false,
      secretKey: '',
      currdatetime: ''
    };
  },
  methods: {
    edit(record, flg) {
      this.title = flg == '1' ? '查看密钥' : '重置密匙';
      this.graphicCode = '';
      this.secretKey = flg == '1' ? record.secretKey : '';
      this.recordId = '';
      this.visible = true;
      this.recordId = record.id;
      this.isReset = flg == '1' ? false : true;
      this.getGraphicCode();
    },
    getGraphicCode() {
      this.currdatetime = new Date().getTime();
      getAction(
        process.env.VUE_APP_CMS_SYSTEM + `/sys/randomImage/${this.currdatetime}`
      ).then(res => {
        if (res.success) {
          this.codeImg = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleReset() {
      let requestUrl = '';
      if (this.isReset) {
        requestUrl = this.url.resetKey;
      } else {
        requestUrl = this.url.checkKey;
      }
      let params = {
        id: this.recordId,
        checkKey: this.currdatetime,
        captcha: this.graphicCode
      };
      getAction(requestUrl, params).then(res => {
        if (res.success) {
          this.secretKey = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleCancel() {
      this.visible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.code {
  width: 100%;
  display: flex;
  align-items: center;
  .ant-btn {
    margin-left: 10px;
  }
}
</style>
